var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accountoffers"},[_c('h2',{staticClass:"not-visible",attrs:{"data-focus":""}},[_vm._v(_vm._s(_vm.$t('page.accountOffers.title')))]),_c('account-offers-grid',{attrs:{"user-address":_vm.userAddress}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }